// extracted by mini-css-extract-plugin
module.exports = {"landing":"MainLanding_landing__Zzix8","landing__faq-link":"MainLanding_landing__faq-link__m6rDT"};